import { putLeadRating } from "../../../api/crm/leadRating"

export function createLeadRatingChangeHandler({
  axios,
  leadSource,
  setLeads,
  setIsTableLoading,
  openSnackbar,
}) {
  return (lead) => (e, newValue) => {
    e.stopPropagation()
    if (setIsTableLoading) {
      setIsTableLoading(true)
    }
    setLeads((prev) =>
      prev.map((row) =>
        String(row.id) === String(lead.id) ? { ...row, rating: newValue } : row
      )
    )
    putLeadRating(axios, leadSource, lead.id, newValue)
      .then(() => {
        openSnackbar("Rating updated successfully")
      })
      .catch(() => {
        openSnackbar("Could not update rating. Try again.")
      })
      .finally(() => {
        if (setIsTableLoading) {
          setIsTableLoading(false)
        }
      })
  }
}
